// Sperrschicht über der App, wenn sie nach einer Pause zurückkommt.
//
// Sie liegt bewusst ÜBER der Oberfläche und ersetzt sie nicht: so bleibt der
// Zustand erhalten — eine halb getippte Rechnung ist nach dem Entsperren noch
// da. Eine Weiterleitung auf die Anmeldeseite hätte sie verworfen.
//
// Nur in der nativen App sichtbar. Im Browser gibt es nichts zu sperren, dort
// übernimmt das die Sitzung.
import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../../../gemeinsam/lib/AuthContext';
import { useSprache } from '../../../gemeinsam/lib/i18n';
import { Knopf, Spinner } from '../../../gemeinsam/komponenten/Basis';
import { LogoKachel } from '../../firma/komponenten/Logo';

export default function Biometriesperre() {
  const { t } = useSprache();
  const { entsperren, abmelden, benutzer } = useAuth();
  const [laeuft, setLaeuft] = useState(true);
  const [abgelehnt, setAbgelehnt] = useState(false);

  const versuchen = useCallback(async () => {
    setLaeuft(true);
    setAbgelehnt(false);
    const ok = await entsperren();
    if (!ok) setAbgelehnt(true);
    setLaeuft(false);
  }, [entsperren]);

  // Beim Erscheinen sofort fragen — niemand soll erst einen Knopf suchen.
  useEffect(() => { void versuchen(); }, [versuchen]);

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-950 px-6">
      <div className="w-full max-w-xs text-center">
        <LogoKachel groesse="gross" klasse="mx-auto mb-6 shadow-lg shadow-marke-600/25" />
        <p className="font-semibold text-slate-100">{t('sperre.titel')}</p>
        {benutzer?.name && (
          <p className="mt-1 text-sm text-slate-400">{benutzer.name}</p>
        )}

        <div className="mt-8">
          {laeuft ? (
            <Spinner />
          ) : (
            <div className="space-y-2">
              {abgelehnt && (
                <p className="mb-4 text-sm text-slate-400">{t('sperre.abgebrochen')}</p>
              )}
              <Knopf variante="primaer" className="w-full" onClick={versuchen}>
                {t('sperre.entsperren')}
              </Knopf>
              <button type="button" onClick={abmelden}
                      className="w-full py-2 text-xs text-slate-500 hover:underline">
                {t('aktion.abmelden')}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
